import { WORKOUT_SECTION_KEY } from '../../../model'
import updateWorkoutSectionAction from '../update'
import WORKOUT_SECTIONS_ACTION from '../../constants/action'

function updateNameWorkoutSectionAction (name) {
  return updateWorkoutSectionAction({
    type: WORKOUT_SECTIONS_ACTION.UPDATE_NAME,
    payload: {
      key: WORKOUT_SECTION_KEY.NAME,
      value: name,
      omitWorkoutUpdate: true
    }
  })
}

export default updateNameWorkoutSectionAction
